function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1429 3.70534C11.1429 4.93078 9.90402 6.06918 9.88393 6.08927L6 9.83257L2.10938 6.08257C2.09598 6.06918 0.857143 4.93078 0.857143 3.70534C0.857143 1.82364 2.12946 1.42855 3.20089 1.42855C4.19866 1.42855 5.32366 2.50668 5.67188 2.92186C5.83259 3.11605 6.16741 3.11605 6.32812 2.92186C6.67634 2.50668 7.80134 1.42855 8.79911 1.42855C9.87054 1.42855 11.1429 1.82364 11.1429 3.70534ZM12 3.70534C12 1.74328 10.8013 0.571411 8.79911 0.571411C7.62723 0.571411 6.52902 1.49552 6 2.01784C5.47098 1.49552 4.37277 0.571411 3.20089 0.571411C1.19866 0.571411 0 1.74328 0 3.70534C0 5.31248 1.47321 6.65846 1.52679 6.70534L5.70536 10.7366C5.78571 10.817 5.89286 10.8571 6 10.8571C6.10714 10.8571 6.21429 10.817 6.29464 10.7366L10.4665 6.71873C10.5268 6.65846 12 5.31248 12 3.70534Z",
  fill: "#D82067"
});

var SvgHeart = function SvgHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Heart.c9450519.svg";
export { ForwardRef as ReactComponent };